import React, { useEffect, useRef, useState } from "react"
import Header from "../commonComponents/Header"
import video from "../assets/video.mp4"
import mecca from "../assets/mecca_image.jpg"
import musicPlay from "../assets/green/play2.png";
import musicPause from "../assets/green/pause2.png";
import { SendGuiDataEvents } from "../lib/CommonScript";


function MakkahLive() {

    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    const onClickHandler = () => {
        if (isPlaying) {
            audioRef.current.pause();
            setIsPlaying(false);
        } else {
            audioRef.current.play();
            setIsPlaying(true);
        }

    }

    useEffect(() => {
        //send gui events
        let guiDataEvent = {};
        guiDataEvent["w_action"] = "card_click";
        guiDataEvent["name"] = "makkah_live";
        SendGuiDataEvents(guiDataEvent);
      }, []);

    const audioLink = "http://stream.radiojar.com/4wqre23fytzuv"

    return (

        <div className='max-w-[500px] relative h-[100vh]'>
            <Header />
            <div className='top-12 absolute h-full w-full z-[-1] max-w-[500px]'>
                <video
                    className='w-full max-w-[500px] h-full object-cover'
                    src={video}
                    autoPlay
                    loop
                    muted
                />
            </div>
            <div className='absolute top-20 w-full  '>
                <h1 className='text-2xl text-white font-bold'>استمع للصلاة مباشرة من رحاب مكة المكرمة</h1>

                <h1 className='mt-4 text-2xl text-white font-bold'>وآيات عطرة من القرآن الكريم من خلال</h1>

                <div className='mt-16 mx-8 flex'>

                    <img src={mecca} className="w-20" />


                    <div className="pl-2 w-full bg-[#40576E]">
                        <audio className="hidden" src={audioLink} ref={audioRef} />
                        <div className="float-left text-white">Live From Mecca - <span className="text-[#808080]">BNG</span> </div>
                        <div className="bg-[#40576E] mt-8">
                            <img onClick={onClickHandler} src={isPlaying ? musicPause : musicPlay} className="w-8" />
                        </div>

                    </div>

                </div>
            </div>



        </div>
    )
}

export default MakkahLive
